module.exports = __webpack_public_path__ + "static/image/reporter-p4.svg?70209f4b27f653d0707770a40c479d94";